import { gql } from '@apollo/client';

export type RestoreTmsTaskResponse = {
  opsToolRestoreTmsTask: {
    success: boolean;
    code: string;
    message: string;
    updatedCount: number | null;
  };
};

export const RESTORE_TMS_TASK = gql`
  mutation OpsToolRestoreTmsTask($taskId: Long!) {
    opsToolRestoreTmsTask(taskId: $taskId) {
      success
      code
      message
      updatedCount
    }
  }
`;

export type DeleteTmsTaskResponse = {
  opsToolDeleteTmsTask: {
    success: boolean;
    code: string;
    message: string;
    updatedCount: number | null;
  };
};

export const DELETE_TMS_TASK = gql`
  mutation OpsToolDeleteTmsTask($taskId: Long!) {
    opsToolDeleteTmsTask(taskId: $taskId) {
      success
      code
      message
      updatedCount
    }
  }
`;

/** 强类型补丁三态：键为字段名；不传 = 不改，null = 置空，其余为已按类型转换的值（数字 / 布尔 / 日期时间字符串） */
export type TmsTaskFieldsInput = Record<string, string | number | boolean | null>;

export type UpdateTmsTaskFieldsResponse = {
  opsToolUpdateTmsTaskFields: {
    success: boolean;
    code: string;
    message: string;
    updatedCount: number | null;
  };
};

export const UPDATE_TMS_TASK_FIELDS = gql`
  mutation OpsToolUpdateTmsTaskFields($taskId: Long!, $expectedUpdatedAt: String, $fields: OpsTmsTaskFieldsInput!) {
    opsToolUpdateTmsTaskFields(taskId: $taskId, expectedUpdatedAt: $expectedUpdatedAt, fields: $fields) {
      success
      code
      message
      updatedCount
    }
  }
`;

/** 途经点强类型补丁三态：不传 = 不改，null = 置空，其余为已按类型转换的值；照片列为 S3 key 数组的 JSON 字符串 */
export type TmsTaskWaypointFieldsInput = Record<string, string | number | null>;

export type UpdateTmsTaskWaypointFieldsResponse = {
  opsToolUpdateTmsTaskWaypointFields: {
    success: boolean;
    code: string;
    message: string;
    updatedCount: number | null;
  };
};

export const UPDATE_TMS_TASK_WAYPOINT_FIELDS = gql`
  mutation OpsToolUpdateTmsTaskWaypointFields($taskWaypointId: Long!, $expectedUpdatedAt: String, $fields: OpsTmsTaskWaypointFieldsInput!) {
    opsToolUpdateTmsTaskWaypointFields(taskWaypointId: $taskWaypointId, expectedUpdatedAt: $expectedUpdatedAt, fields: $fields) {
      success
      code
      message
      updatedCount
    }
  }
`;

export type RecomputeTmsStaticEtaResponse = {
  opsToolRecomputeTmsStaticEta: { success: boolean; code: string; message: string; updatedCount: number | null };
};

export const RECOMPUTE_TMS_STATIC_ETA = gql`
  mutation OpsToolRecomputeTmsStaticEta($taskId: Long!, $taskWaypointId: Long!) {
    opsToolRecomputeTmsStaticEta(taskId: $taskId, taskWaypointId: $taskWaypointId) {
      success
      code
      message
      updatedCount
    }
  }
`;
